import React from 'react';
import { sizes } from '@sharefiledev/antd-config';
import { Skeleton, Spin } from 'antd';
import { ExtensionProps } from '../Common';
import { NotificationCenterParams } from './NotificationsCenter';

const LazyNotificationsCenter = React.lazy(() => import('./NotificationsCenter'));
export const AsyncLazyNotificationsCenter: React.FC<NotificationCenterParams> = props => (
	<React.Suspense fallback={<Skeleton />}>
		<LazyNotificationsCenter {...props} />
	</React.Suspense>
);

const LazyDevPage = React.lazy(() => import('./DevPage'));
export const AsyncLazyDevPage: React.FC<ExtensionProps> = props => (
	<React.Suspense fallback={<Skeleton />}>
		<LazyDevPage {...props} />
	</React.Suspense>
);

const LazyDevPageIcon = React.lazy(() => import('./LazyLoadDevIcon'));
export const AsyncLazyDevPageIcon: React.FC<{ size: number }> = props => (
	<React.Suspense
		fallback={<Spin style={{ paddingBottom: sizes.XS, paddingRight: sizes.MD }} />}
	>
		<LazyDevPageIcon {...props} />
	</React.Suspense>
);
